import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import SampleSnackbar from "./SampleSnackbar";
import SnackbarCustomization from "./SnackbarCustomization";
import PositionedSnackbars from "./PositionedSnackbars";
import ControlSlideDirection from "./ControlSlideDirection";

const SnackbarPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Snackbar"}
        description={
          "Snackbars provide brief notifications. The component is also known as a toast."
        }
      />
      <Divider light />

      <SampleSnackbar />
      <SnackbarCustomization />
      <PositionedSnackbars />
      <ControlSlideDirection />
    </Paper>
  );
};

export default SnackbarPage;
